import React from "react";
import "../css/LandingFooter.css";
import logo from "../../assets/merchant-marvels.jpg";

export default function LandingFooter() {
  return (
    <footer className="landingFooter" role="contentinfo">
      <div className="landingFooter__inner">
        {/* Logo placeholder (keep blank until you upload your logo) */}
        <div className="landingFooter__logo" aria-label="Company logo placeholder">
          <img className="landingFooter__logoImg" src={logo} alt="Merchant Marvels Logo" />
        </div>

        <p className="landingFooter__line">
          The Clover name and logo are owned by Clover Network, Inc. a wholly owned subsidiary of First Data corporation, and are registered or used in the U.S. and many foreign countries.
         </p>
          <p className="landingFooter__line">
            All trademarks and registered trademarks are the property of their respective owners. For Enquires Call Us Now at +1(302) 208-6030 or email us at admin@merchantmarvels.com
          </p>

        <p className="landingFooter__line landingFooter__copyright">
          © Copyright 2018 - 2026 Merchant marvels. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}